const radioData = [

  {
    id: 1,
    title: "Beats Radio",
    img: "/images/radio/beats.png",
    tag: "radio online",
    url: "https://streaming01.shockmedia.com.ar/9778/stream",
    url2: "",
  },

  {
    id: 2,
    title: "Cadena 3",
    img: "/images/radio/cadena3.jpg",
    tag: "radio online",
    url: "https://21933.live.streamtheworld.com/RADIO3.mp3",
    url2: "",
  },


  {
    id: 3,
    title: "La Popu",
    img: "/images/radio/lapopufm.png",
    tag: "radio online",
    url: "https://27363.live.streamtheworld.com/LAPOPU.mp3?dist=c3-web",
    url2: "https://liveradio.mediainbox.net/popular.mp3",
  },

  {
    id: 4,
    title: "Mas FM",
    img: "/images/radio/masfm.png",
    tag: "radio online",
    url: "https://01.solumedia.com.ar:8596/stream",
    url2: "",
  },


  {
    id: 6,
    title: "Radio FM Siempre 90.30",
    img: "/images/radio/fmsiempre.jpeg",
    tag: "radio online",
    url: "https://stream-176.zeno.fm/s05bsshh5f8uv?zt=eyJhbGciOiJIUzI1NiJ9.eyJzdHJlYW0iOiJzMDVic3NoaDVmOHV2IiwiaG9zdCI6InN0cmVhbS0xNzYuemVuby5mbSIsInJ0dGwiOjUsImp0aSI6InpSYjIzVXRUUWtPZ3hLUFBzenVZUGciLCJpYXQiOjE3NTY0OTE1NTIsImV4cCI6MTc1NjQ5MTYxMn0.tu2F0W5A3D1x2nJ9aTh_Kng74QTGd4mUBJjsoxAbd-4",
    url2: "",
  },

  {
    id: 7,
    title: "Blue Fm",
    img: "/images/radio/blue.jpeg",
    tag: "radio online",
    url: "https://26573.live.streamtheworld.com/BLUE_FM_100_7_SC",
    url2: "",
  },
  {
    id: 8,
    title: "Radio Disney",
    img: "/images/radio/radiodisney.jpeg",
    tag: "radio online",
    url: "https://playerservices.streamtheworld.com/api/livestream-redirect/DISNEY_ARG_BA.mp3?dist=web-radiodisney&bundle-id=com.disney.radiodisneybrazil_goo",

  },

  {
    id: 9,
    title: "Radio maria",
    img: "/images/radio/radiomaria.jpeg",
    tag: "radio online",
    url: "https://cdn.instream.audio/:9141/stream",
    url2: "",
  },

  {
    id: 11,
    title: "Radio Delta",
    img: "/images/radio/delta.png",
    tag: "radio online",
    url: "https://cdn.instream.audio/:9069/stream",
    url2: "",
  },

  {
    id: 12,
    title: "Radio Nacional",
    img: "https://www.radionacional.com.ar/reproductor/images/Logo_AM870_b.png",
    tag: "radio online",
    url: "https://sa.mp3.icecast.magma.edge-access.net/sc_rad1",
    url2: "",
  },


];
module.exports = radioData;
